"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


// Needed as the zIndex works with absolute values.
var zIndex = {
  mobileStepper: 900,
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  navDrawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

exports.default = zIndex;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/styles/zIndex.js
// module id = 672
// module chunks = 0